module.exports = __webpack_public_path__ + "static/assem1-d20aaf1f10c120b7e8d7008d24709760.gif";